"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var sendBoxValue = _ref.sendBoxValue;
  return sendBoxValue;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWxlY3RvcnMvc2VuZEJveFZhbHVlLmpzIl0sIm5hbWVzIjpbInNlbmRCb3hWYWx1ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztlQUFlO0FBQUEsTUFBR0EsWUFBSCxRQUFHQSxZQUFIO0FBQUEsU0FBc0JBLFlBQXRCO0FBQUEsQyIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0ICh7IHNlbmRCb3hWYWx1ZSB9KSA9PiBzZW5kQm94VmFsdWU7XG4iXX0=